import React from "react";
import "./welcome.css";
import backimage from "../../images/green2.jpg";
import frontimage from "../../images/cover2.jpg";
import { Link } from "react-router-dom";

export default function Aboutus() {
  return (
    <div className="aboutus">
      <img src={backimage} alt="" className="image" />
      <div className="content">
        <img src={frontimage} alt="" />
        <div>
          <div className="actualwords">
            <h2 className="welcomee">Welcome to</h2>
            <h2 className="welcomee2">LAFEMA SYSTEMS LIMITED</h2>
            <p>
              Congratulations for choosing LAFEMA SYSTEMS, we provide the very
              best of the best car tracking systems around the world. We are
              here to assist you make a successful registration. Should you have
              any challenges at any step, kindly use the support contact email
              support@lafemasystems.co.ke. We look forward to working with you.
            </p>
            <Link to="/account">
              <button className="getstartedbut">Get Started</button>
            </Link>
            <div className="spacer" />
          </div>
        </div>
      </div>
    </div>
  );
}
